import {
    Component,
    OnInit,
    Input,
    OnChanges,
    Output,
    EventEmitter,
} from '@angular/core';
import { ActuationService } from '../../../services/actuation.service';
import { ActuationOperation } from 'app/modules/common/enums/actuationOperation';

export type PendingTask = {
    checked: boolean;
    tipo: number;
};

@Component({
    selector: 'visit-pending-task',
    templateUrl: './pending-task.component.html',
    styleUrls: ['./pending-task.component.scss'],
    standalone: false
})
export class PendingTaskComponent implements OnInit, OnChanges {
    @Input() ActuationOperation: number;
    @Input() LeaveInfo: any;
    @Input() LeaveId: number;
    @Input() ActuationType: number;

    @Input() PendingTasks: PendingTask[];
    @Output() PendingTasksChange = new EventEmitter<PendingTask[]>();

    constructor(public actuationService: ActuationService) {}

    ngOnChanges() {
        if (!this.LeaveId) this.LeaveId = this.LeaveInfo?.bajaId;

        if (this.LeaveId && this.PendingTasks) {
            this.loadPendingTasks();
        }
    }

    ngOnInit() {}

    private loadPendingTasks() {
        this.actuationService.getPendingTasks(this.LeaveId).subscribe((res) => {
            if (res.code == 0) {
                // empty tasks list
                this.PendingTasks.length = 0;
                const actuType = this.ActuationType;
                const actuOp = this.ActuationOperation;
                res.result.map((t: PendingTask) => {
                    if (actuType == 10131) {
                        t.checked =
                            t.tipo == 30201 ||
                            t.tipo == 31201 ||
                            t.tipo == 10131;
                    } else if (actuType == 10310) {
                        t.checked = t.tipo == 10113;
                    } else if (actuType == 10911) {
                        t.checked =
                            t.tipo == 10201 ||
                            t.tipo == 31102 ||
                            t.tipo == 31202;
                    } else if (actuType == 13001) {
                        t.checked = t.tipo == 13001;
                    } else if (actuType >= 13013 && actuType <= 13016) {
                        t.checked = t.tipo == 13011 || t.tipo == 14011;
                    } else if (
                        (actuType >= 13101 && actuType <= 13113) ||
                        (actuType >= 30101 && actuType <= 31999) ||
                        actuType == 13002 ||
                        actuOp == ActuationOperation.Contacto ||
                        actuOp == ActuationOperation.Visita ||
                        actuOp == ActuationOperation.VisitaAusente ||
                        actuOp == ActuationOperation.PrimerContacto ||
                        actuOp == ActuationOperation.ContactoFallido
                    ) {
                        t.checked =
                            t.tipo == 10113 ||
                            t.tipo == 30101 ||
                            t.tipo == 30102 ||
                            t.tipo == 30109 ||
                            t.tipo == 31101 ||
                            t.tipo == 31102 ||
                            t.tipo == 31109 ||
                            t.tipo == 31131;
                    } else if (actuType == 14001) {
                        t.checked = t.tipo == 14001;
                    } else if (actuType == 14002) {
                        t.checked = t.tipo == 14001 || t.tipo == 14002 || t.tipo == 30102;
                    } else if (actuType == 14011 || actuType == 14019) {
                        t.checked = t.tipo == 14011;
                    }
                    else if (actuType == 15001) {
                        t.checked = t.tipo == 15001;
                    } else if (actuType == 15002) {
                        t.checked = t.tipo == 15001 || t.tipo == 15002 || t.tipo == 30102;
                    } 
                    else if (actuType == 25102) {
                        t.checked = t.tipo == 35002;
                    } else if (actuType >= 36001 && actuType <= 36099) {
                        t.checked = t.tipo == actuType;
                    } else if (actuType == 29001) {
                        t.checked = true;
                    }

                    this.PendingTasks.push(t);
                });

                this.PendingTasksChange.emit(this.PendingTasks);
            }
        });
    }
}
